// extracted by css-extract-rspack-plugin
export default {"wrapper":"bOs9K","width_expand":"oRZcu","widthExpand":"oRZcu","search_button_override":"eU7_M","searchButtonOverride":"eU7_M","#":"TFaKj"};